module.exports = __webpack_public_path__ + "img/sameday_dfod_k.94e6be5e.png";